import soundPlayService from "@/services/soundPlayService";

const user = JSON.parse(localStorage.getItem('user'));
const initialState = {
    requestToReceived : null,
}

export const requestHub = {
    namespaced: true,
    state: initialState,
    actions: {
    },
    mutations: {
        requestToReceived(state, data) {
            state.requestToReceived = data;
            soundPlayService.playNewNotification();
        }
    },
    getters: {
        requestToReceived() {
           return state.requestToReceived;
        },
    }
};